export enum ActivityLoadStatus {
  NONE,
  FAILED,
  COMPLETE
}
